(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cantemiri-drawer-base"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cm-lux-menu')) customElements.define('cm-lux-menu',class extends HTMLElement{
  connectedCallback(){
    this.dialog=this.querySelector('dialog');
    this.trigger=this.querySelector('[data-menu-open]');
    this.controller=new AbortController();
    const options={signal:this.controller.signal};
    this.trigger.hidden=false;
    this.querySelector('[data-menu-fallback]').hidden=true;
    this.trigger.addEventListener('click',()=>{this.dialog.showModal();this.trigger.setAttribute('aria-expanded','true');},options);
    this.querySelector('[data-menu-close]').addEventListener('click',()=>this.dialog.close(),options);
    this.dialog.addEventListener('click',event=>{
      if(event.target!==this.dialog)return;
      const rect=this.dialog.getBoundingClientRect();
      if(event.clientX<rect.left||event.clientX>rect.right||event.clientY<rect.top||event.clientY>rect.bottom)this.dialog.close();
    },options);
    this.dialog.addEventListener('close',()=>{
      this.trigger.setAttribute('aria-expanded','false');
      this.trigger.focus();
    },options);
    // Keep this parent drawer open while Shopify's native account sheet is active.
    // Closing a dialog containing <shopify-account> immediately destroys/hides
    // its sheet, causing the sign-in panel to flash and disappear.
    this.dialog.querySelectorAll('a').forEach(a =>
      a.addEventListener('click',()=>this.dialog.close(),options)
    );
  }
  disconnectedCallback(){
    if(this.dialog?.open)this.dialog.close();
    this.controller?.abort();
  }
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cantemiri-size-guide"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('cm-ring-guide'))customElements.define('cm-ring-guide',class extends HTMLElement{
  connectedCallback(){
    this.controller=new AbortController();
    const form=this.querySelector('form');
    const result=this.querySelector('[data-result]');
    const input=form?.elements.measurement_value;
    const type=form?.elements.measurement;
    if(!form||!result||!input||!type)return;

    type.addEventListener('change',()=>{
      input.placeholder=type.value==='diameter'?'17.3':'54.4';
      input.value='';
      result.innerHTML='<span>'+result.dataset.empty+'</span>';
      this.querySelectorAll('[data-selected]').forEach(row=>row.removeAttribute('data-selected'));
    },{signal:this.controller.signal});

    form.addEventListener('submit',event=>{
      event.preventDefault();
      const raw=input.value.trim().replace(',','.');
      const value=/^\d+(\.\d+)?$/.test(raw)?Number(raw):NaN;
      const kind=type.value;
      const rows=[...this.querySelectorAll('tbody tr')];
      rows.forEach(row=>row.removeAttribute('data-selected'));

      if(!Number.isFinite(value)||value<=0){
        result.textContent=result.dataset.invalid;
        return;
      }

      const min=Number(rows[0].dataset[kind]);
      const max=Number(rows[rows.length-1].dataset[kind]);
      if(value<min||value>max){
        result.textContent=result.dataset.outside;
        return;
      }

      const nearest=rows.reduce((a,b)=>Math.abs(Number(b.dataset[kind])-value)<=Math.abs(Number(a.dataset[kind])-value)?b:a);
      nearest.setAttribute('data-selected','');
      result.innerHTML='<span>'+result.dataset.label+'</span><strong>US '+nearest.dataset.size+'</strong>';
      nearest.scrollIntoView({block:'nearest',behavior:'smooth'});
    },{signal:this.controller.signal});
  }
  disconnectedCallback(){this.controller?.abort();}
});
  } catch(e) { console.error(e); }
})();

})();
